import React, { forwardRef, useState, useImperativeHandle } from 'react';
import Dialog from "@mui/material/Dialog/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import {Button, DialogActions, DialogTitle, TextField} from "@mui/material";
import {SubmitHandler, useForm} from "react-hook-form";
import helpers from "../../utils/helpers";

//**********************************************************

interface FormAlarmSpeed
{
    maxSpeed: number
}

//**********************************************************

const Index = forwardRef((props:{mobileNumber:string, smsCode: string, lastSpeed: string, callback: any}, ref) =>
    {
        const [isOpen, setIsOpen] = useState(false);

        useImperativeHandle
        (
            ref, () =>
                (
                    {
                        show: () => { setIsOpen(true); },
                        hide: () => { setIsOpen(false); },
                    }
                )
        );

        const handleClose = () =>
        {
            setIsOpen(false);
        };

        // form
        const { register, formState: { errors }, handleSubmit } = useForm<FormAlarmSpeed>({defaultValues: {maxSpeed: helpers.isNumeric(props.lastSpeed) ? parseInt(props.lastSpeed) : 0}})
        const onSubmitFormAlarmSpeed: SubmitHandler<FormAlarmSpeed> = (formData:FormAlarmSpeed) =>
        {
            if(formData.maxSpeed > 0)
            {
                // window.open(props.smsCode.replace('MaxSpeed', formData.maxSpeed.toString()));
                helpers.sendSms(props.mobileNumber, props.smsCode.replace('MaxSpeed', (formData.maxSpeed * 1).toString()));
                props.callback(formData.maxSpeed * 1);
                handleClose();
            }
        }

        //--------------------
        return(
            <Dialog open={isOpen} onClose={handleClose} PaperProps={{component: 'form', onSubmit: handleSubmit(onSubmitFormAlarmSpeed)}}>
                <DialogTitle>هشدار سرعت</DialogTitle>

                <DialogContent>
                    <TextField type="number" className="t2" label="سرعت خود را وارد نمایید" id="FormAlarmSpeedMaxSpeed" variant="filled" dir="ltr" {...register("maxSpeed", {required: true})} error={errors.maxSpeed?.type === "required"} />
                </DialogContent>

                <DialogActions>
                    <Button size="medium" variant="outlined" onClick={handleClose}>لغو</Button>
                    <Button type="submit" size="medium" variant="contained" color="success">ارسال</Button>
                </DialogActions>
            </Dialog>
        );
    }
);

export default Index;
